import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnChanges,
    SimpleChanges,
    ViewChild,
} from '@angular/core';

@Component({
    selector: 'rdx-rating-display',
    styleUrls: ['../rating.component.scss'],
    templateUrl: './rating-display.component.html',
})
export class RatingDisplayComponent implements AfterViewInit, OnChanges {
    @Input() rating: number;

    @ViewChild('starsInput') private starsInput?: ElementRef<HTMLDivElement>;

    ngAfterViewInit(): void {
        this.updateRating();
    }

    ngOnChanges(changes: SimpleChanges) {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (changes.rating && changes.rating.currentValue) {
            this.updateRating();
        }
    }

    updateRating() {
        this.starsInput?.nativeElement.style.setProperty(
            '--star-rating',
            String(this.rating || 0)
        );
    }
}
